export default __webpack_public_path__ + "static/media/q1_answer.24ce41f5.jpg";